import {Button} from "@/app/_components";
import styles from "./Step1_2.module.css";

type Step1Props = {
    target?: () => HTMLElement | null;
    currentStep?: number;
    currIndex: number;
    onNext?: (idx: number) => void;
}

const buttonStyle: React.CSSProperties = {
    color: "#fff",
    width: "3.7rem",
    height: "1.1rem",
    fontWeight: 900,
    fontSize: ".5rem"
}

const Step1: React.FC<Step1Props> = props => {
    const { target, currentStep, currIndex, onNext } = props;

    const _targetStyle = target?.()?.getBoundingClientRect();
    if (!_targetStyle) return;

    const { x, y, width, height } = _targetStyle;
    const wrapperStyle: React.CSSProperties = {
        position: 'absolute',
        width: width,
        height: height,
        top: y,
        left: x,
    }

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // e.stopPropagation();
        // onNext && onNext(currIndex + 1)
    }

    return (
        <>
            {(currentStep === currIndex) && <div style={wrapperStyle} >
                <div className={styles.step1}>
                    <img src="/img/guide/xsyd_1.webp" width={width} height={height} alt=""/>
                    <div className={styles.arrow}></div>
                    <div className={styles.popover}>
                        Play with
                        <img className={styles.gold_icon} src="/img/ico_gc.png" alt=""/>
                        <span style={{color: '#EE8A08', fontWeight: 900}}>GOLD COINS for fun </span>
                        in any game & earn Loyalty
                        Points to win rewards.
                        <div className={styles.button}>
                            <Button color="#0090FF" style={buttonStyle} onClick={handleClick}>Great</Button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Step1;